import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { $dataRuleCache, $onChangeCache, $validationCache } from '../../state/validations'

export function useRuleEngineCache(entityName: string, formName: string) {
  const params = useMemo(() => {
    const map = new Map()
    map.set('entityName', entityName)
    map.set('formName', formName)
    return map
  }, [entityName, formName])

  const cachedValidation = useRecoilValue($validationCache(params))
  const cachedDataRules = useRecoilValue($dataRuleCache(params))
  const cachedOnChange = useRecoilValue($onChangeCache(params))
  return {
    cachedValidation,
    cachedDataRules,
    cachedOnChange,
  }
}
